export interface AlbumItem {
  id: string;
  title: string;
  model: string;
  category: string;
  tags: string[];
  date: string;
  views: string;
  count: string;
  desc: string;
  cover: string;
}

export const galleryTabs: string[] = [
  "全部",
  "私拍写真",
  "时尚写真",
  "户外外拍",
  "居家日常",
  "制服系列",
  "复古胶片",
];

export const latestAlbums: AlbumItem[] = [
  {
    id: "latest-01",
    title: "晨光里的丝质长裙",
    model: "苏念",
    category: "私拍写真",
    tags: ["柔光", "室内", "长裙"],
    date: "2026-10-06",
    views: "18.2 万",
    count: "48 张",
    desc: "清晨侧逆光透过纱帘落在裙摆上，摄影师用一盏主灯收拢轮廓，整体色调偏暖，皮肤质感通透。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20east%20asian%20woman%20portrait%20in%20long%20champagne%20silk%20dress%2C%20soft%20morning%20side%20light%20through%20sheer%20curtain%2C%20warm%20cream%20studio%20interior%2C%20graceful%20pose%2C%20refined%20editorial%20glamour%20photography%2C%20tasteful%20warm%20tones%2C%20high%20detail&width=600&height=800&seq=yv-latest-01&orientation=portrait",
  },
  {
    id: "latest-02",
    title: "落地窗与白衬衫",
    model: "林亦薇",
    category: "居家日常",
    tags: ["自然光", "清新", "日常"],
    date: "2026-10-05",
    views: "15.7 万",
    count: "36 张",
    desc: "明亮的落地窗提供均匀的散射光，白衬衫与米色墙面形成干净的层次，画面松弛且亲近，适合喜欢清新风格的用户。",
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20east%20asian%20woman%20portrait%20in%20oversized%20white%20shirt%20beside%20large%20bright%20window%2C%20diffused%20daylight%2C%20minimal%20warm%20beige%20room%2C%20relaxed%20natural%20pose%2C%20clean%20airy%20aesthetic%2C%20soft%20film%20tones%2C%20editorial%20portrait&width=600&height=800&seq=yv-latest-02&orientation=portrait",
  },
  {
    id: "latest-03",
    title: "城市天台逆光",
    model: "顾清欢",
    category: "户外外拍",
    tags: ["逆光", "城市", "黄金时段"],
    date: "2026-10-03",
    views: "21.4 万",
    count: "52 张",
    desc: "黄金时段的天台，逆光勾出人物边缘的轮廓光，背景城市剪影被压暗，暖调氛围感拉满，是本周浏览量最高的一组。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylish%20east%20asian%20woman%20portrait%20on%20city%20rooftop%20at%20golden%20hour%2C%20backlit%20rim%20light%20on%20hair%2C%20urban%20skyline%20soft%20bokeh%2C%20warm%20amber%20cinematic%20tones%2C%20confident%20graceful%20pose%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=yv-latest-03&orientation=portrait",
  },
  {
    id: "latest-04",
    title: "复古胶片红裙",
    model: "沈曜",
    category: "复古胶片",
    tags: ["胶片", "复古", "颗粒"],
    date: "2026-10-01",
    views: "13.9 万",
    count: "40 张",
    desc: "以胶片拍摄完成，保留明显的颗粒与轻微偏色。深红长裙在暖黄旧巷中格外醒目，反差柔和，有很强的年代叙事感。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20styled%20east%20asian%20woman%20portrait%20in%20deep%20red%20dress%2C%20retro%20film%20grain%20texture%2C%20warm%20muted%20palette%2C%20old%20brick%20alley%20background%20blurred%2C%20nostalgic%20cinematic%20mood%2C%20elegant%20timeless%20aesthetic%2C%20high%20detail&width=600&height=800&seq=yv-latest-04&orientation=portrait",
  },
  {
    id: "latest-05",
    title: "咖啡馆里的午后微光",
    model: "温瑜",
    category: "时尚写真",
    tags: ["咖啡厅", "暖光", "造型"],
    date: "2026-09-29",
    views: "11.6 万",
    count: "32 张",
    desc: "窗边的木质长桌与暖黄吊灯构成天然布景，人物以侧脸入镜，逆光发丝与咖啡热气一起让画面充满故事感。",
    cover:
      "https://readdy.ai/api/search-image?query=Chic%20east%20asian%20woman%20portrait%20in%20cozy%20cafe%20by%20the%20window%2C%20warm%20afternoon%20light%20with%20backlit%20hair%2C%20wooden%20table%20and%20hanging%20lamp%2C%20muted%20warm%20palette%2C%20lifestyle%20editorial%20photography%2C%20soft%20cinematic%20mood&width=600&height=800&seq=yv-latest-05&orientation=portrait",
  },
  {
    id: "latest-06",
    title: "学院风制服系列",
    model: "白鹿鸣",
    category: "制服系列",
    tags: ["制服", "学院", "干净"],
    date: "2026-09-26",
    views: "10.3 万",
    count: "28 张",
    desc: "白衬衫搭配藏青百褶裙的经典学院配色，背景使用纯色浅灰布景，线条利落，是制服系列中讨论度较高的一组。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20east%20asian%20woman%20portrait%20in%20preppy%20navy%20pleated%20skirt%20uniform%2C%20clean%20light%20grey%20studio%20backdrop%2C%20soft%20even%20lighting%2C%20tidy%20crisp%20lines%2C%20fresh%20youthful%20editorial%20photography%2C%20refined%20minimal%20aesthetic&width=600&height=800&seq=yv-latest-06&orientation=portrait",
  },
  {
    id: "latest-07",
    title: "酒店套房的慵懒午后",
    model: "苏念",
    category: "私拍写真",
    tags: ["室内", "慵懒", "氛围"],
    date: "2026-09-23",
    views: "16.8 万",
    count: "44 张",
    desc: "以酒店房间为场景，纱帘过滤后的光线非常柔和。摄影师保留了较多的环境元素，让人物仿佛自然地停留在画面之中。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20east%20asian%20woman%20portrait%20in%20elegant%20hotel%20suite%2C%20sheer%20curtain%20soft%20filtered%20light%2C%20warm%20beige%20and%20cream%20interior%20tones%2C%20relaxed%20languid%20pose%2C%20editorial%20lifestyle%20photography%2C%20tasteful%20intimate%20ambience%2C%20high%20detail&width=600&height=800&seq=yv-latest-07&orientation=portrait",
  },
  {
    id: "latest-08",
    title: "海边黄昏剪影",
    model: "江晚吟",
    category: "户外外拍",
    tags: ["海边", "黄昏", "剪影"],
    date: "2026-09-20",
    views: "19.5 万",
    count: "46 张",
    desc: "日落时分的海边，粉色与金色交织的天空成为最好的背景。长裙随风扬起，画面通透治愈，是许多人入坑该系列的起点。",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20east%20asian%20woman%20portrait%20at%20seaside%20at%20dusk%2C%20soft%20pink%20and%20gold%20sky%2C%20flowing%20light%20summer%20dress%20in%20breeze%2C%20dreamy%20pastel%20cinematic%20tones%2C%20romantic%20peaceful%20mood%2C%20editorial%20photography%2C%20high%20detail&width=600&height=800&seq=yv-latest-08&orientation=portrait",
  },
];

export const archiveAlbums: AlbumItem[] = [
  {
    id: "archive-01",
    title: "午后书房静物人像",
    model: "林亦薇",
    category: "居家日常",
    tags: ["书房", "自然光", "安静"],
    date: "2026-08-30",
    views: "9.8 万",
    count: "30 张",
    desc: "书架、木头桌面与一杯红茶构成安静的背景，人物低头翻阅的姿态自然，很适合用作审美参考。",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20east%20asian%20woman%20portrait%20reading%20in%20a%20sunlit%20study%2C%20wooden%20desk%20and%20bookshelves%2C%20warm%20natural%20daylight%2C%20quiet%20thoughtful%20pose%2C%20muted%20warm%20tones%2C%20editorial%20lifestyle%20photography%2C%20refined%20minimal%20composition&width=600&height=800&seq=yv-archive-01&orientation=portrait",
  },
  {
    id: "archive-02",
    title: "莫兰迪色系棚拍",
    model: "温瑜",
    category: "时尚写真",
    tags: ["棚拍", "莫兰迪", "造型"],
    date: "2026-08-26",
    views: "12.1 万",
    count: "34 张",
    desc: "低饱和的莫兰迪色背景搭配同色系造型，人物气质冷静克制，是时尚写真里配色最为统一的一组。",
    cover:
      "https://readdy.ai/api/search-image?query=High%20fashion%20east%20asian%20woman%20portrait%20in%20muted%20morandi%20color%20studio%2C%20chic%20modern%20outfit%2C%20soft%20controlled%20lighting%2C%20calm%20composed%20pose%2C%20sculptural%20editorial%20photography%2C%20low%20saturation%20elegant%20palette&width=600&height=800&seq=yv-archive-02&orientation=portrait",
  },
  {
    id: "archive-03",
    title: "老巷子里的街拍",
    model: "沈曜",
    category: "复古胶片",
    tags: ["街拍", "胶片", "旧城"],
    date: "2026-08-22",
    views: "8.6 万",
    count: "26 张",
    desc: "以旧城窄巷为背景的街头写真，砖墙、晾衣绳与斑驳招牌带来浓厚的市井气息，胶片颗粒强化了年代感。",
    cover:
      "https://readdy.ai/api/search-image?query=Candid%20east%20asian%20woman%20street%20portrait%20in%20old%20town%20narrow%20alley%2C%20weathered%20brick%20walls%20and%20shop%20signs%2C%20warm%20retro%20film%20tones%2C%20natural%20walking%20pose%2C%20nostalgic%20documentary%20photography%2C%20soft%20grain%20texture&width=600&height=800&seq=yv-archive-03&orientation=portrait",
  },
  {
    id: "archive-04",
    title: "泳池边的夏日清凉",
    model: "江晚吟",
    category: "户外外拍",
    tags: ["泳池", "夏日", "清凉"],
    date: "2026-08-18",
    views: "14.4 万",
    count: "38 张",
    desc: "阳光下的泳池水波反射出细碎光斑，蓝白配色的造型清爽通透，是夏日主题里最受欢迎的一组。",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20east%20asian%20woman%20portrait%20by%20a%20sunlit%20swimming%20pool%2C%20clear%20water%20sparkle%20reflections%2C%20light%20summer%20outfit%2C%20bright%20airy%20warm%20daylight%2C%20relaxed%20joyful%20pose%2C%20clean%20editorial%20summer%20photography&width=600&height=800&seq=yv-archive-04&orientation=portrait",
  },
  {
    id: "archive-05",
    title: "深夜霓虹微光",
    model: "顾清欢",
    category: "私拍写真",
    tags: ["夜景", "霓虹", "氛围"],
    date: "2026-08-14",
    views: "13.2 万",
    count: "40 张",
    desc: "夜晚街头的霓虹灯成为主要光源，冷色环境与暖色皮肤形成对比，画面情绪强烈，适合喜欢氛围感的收藏者。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20east%20asian%20woman%20portrait%20on%20night%20street%20with%20soft%20neon%20sign%20glow%2C%20cinematic%20color%20contrast%2C%20warm%20skin%20against%20cool%20ambience%2C%20urban%20bokeh%20lights%2C%20editorial%20night%20photography%2C%20high%20detail&width=600&height=800&seq=yv-archive-05&orientation=portrait",
  },
  {
    id: "archive-06",
    title: "白色蕾丝居家时光",
    model: "白鹿鸣",
    category: "居家日常",
    tags: ["蕾丝", "居家", "柔光"],
    date: "2026-08-10",
    views: "10.9 万",
    count: "28 张",
    desc: "以大面积的白色与浅木色营造安静的居家氛围，柔光让材质细节清晰可见，整体观感干净舒服。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20east%20asian%20woman%20portrait%20in%20white%20lace%20loungewear%20at%20home%2C%20light%20wood%20and%20white%20minimal%20interior%2C%20gentle%20diffused%20lighting%2C%20calm%20relaxed%20pose%2C%20clean%20warm%20editorial%20lifestyle%20photography&width=600&height=800&seq=yv-archive-06&orientation=portrait",
  },
  {
    id: "archive-07",
    title: "黑白经典人像",
    model: "苏念",
    category: "时尚写真",
    tags: ["黑白", "经典", "肖像"],
    date: "2026-08-05",
    views: "11.3 万",
    count: "24 张",
    desc: "去除色彩干扰后的黑白人像，更考验光影与面部结构。侧光塑造出明显的立体感，是经典肖像的范例之作。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20black%20and%20white%20portrait%20of%20east%20asian%20woman%2C%20dramatic%20side%20lighting%20sculpting%20the%20face%2C%20neutral%20studio%20backdrop%2C%20timeless%20monochrome%20editorial%20photography%2C%20elegant%20refined%20expression%2C%20high%20detail&width=600&height=800&seq=yv-archive-07&orientation=portrait",
  },
  {
    id: "archive-08",
    title: "天台夜景与城市灯海",
    model: "顾清欢",
    category: "户外外拍",
    tags: ["夜景", "天台", "灯海"],
    date: "2026-07-31",
    views: "15.1 万",
    count: "42 张",
    desc: "站在高处俯瞰整片城市灯海，虚化的灯光化作柔和的散景。人物被微弱的环境光包裹，画面安静又不失张力。",
    cover:
      "https://readdy.ai/api/search-image?query=East%20asian%20woman%20portrait%20on%20rooftop%20at%20night%20overlooking%20city%20light%20bokeh%2C%20soft%20ambient%20glow%2C%20cinematic%20urban%20atmosphere%2C%20calm%20confident%20pose%2C%20warm%20cool%20contrast%20editorial%20night%20photography&width=600&height=800&seq=yv-archive-08&orientation=portrait",
  },
];